import { computed, makeObservable } from 'mobx';
import { FiltersStateStrategyType, FilterType } from 'src/domains/layouts/webview/components/filters/Filters.state';
import { Common } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';
import {
    getTimeFilterIds,
    isSportsTimeFilterType,
    SportsTimeFilterType,
} from 'src/domains/sportsbook/webview/components/sportEventsListNew/SportsFilters/SportsTimeFilter';
import { isFightSport } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedEventsListMarkets';

export class UnifiedSportTimeFilterStrategy implements FiltersStateStrategyType<SportsTimeFilterType | null> {
    public constructor(
        private readonly common: Common,
        private readonly eventsListState: UnifiedSportEventsListState
    ) {
        makeObservable(this);
    }

    @computed public get filters(): FilterType<SportsTimeFilterType>[] {
        const getTranslation = LanguagesState.get(this.common).getTranslation;
        const filterIds = getTimeFilterIds(this.eventsListState.sport);

        return filterIds.map((id) => ({
            id,
            key: id,
            label: this.getTimeFilterLabel(id, getTranslation),
        }));
    }

    public getActiveFilterId(): SportsTimeFilterType | null {
        return this.eventsListState.filter_time;
    }

    public setActiveFilterId(id: string | number | null): void {
        if (typeof id === 'string' && isSportsTimeFilterType(id, this.eventsListState.sport)) {
            this.eventsListState.setFilterTime(id);
        }
    }

    private getTimeFilterLabel(
        id: SportsTimeFilterType,
        getTranslation: (langKey: string, defaultText: string) => string
    ): string {
        switch (id) {
            case 'all':
                return isFightSport(this.eventsListState.sport)
                    ? getTranslation('events.time-options.all-fights', 'All Fights')
                    : getTranslation('events.time-options.all-matches', 'All matches');
            case 'today':
                return getTranslation('events.time-options.today', 'Today');
            case 'tomorrow':
                return getTranslation('events.time-options.tomorrow', 'Tomorrow');
            case 'current-week':
                return getTranslation('events.time-options.current-week', 'Current week');
            case 'next-week':
                return getTranslation('events.time-options.next-week', 'Next week');
        }
    }
}
